import { dispatch, req } from "hf-rt";

const initialState = {
  getCountriesList: false,
  getMenuCountriesList: false,
  countries: [],
  menuCountries: [],
  region: [],
  countryCode: "",
  dutyTax: {
    minHandleChargeCurrency: "HK$"
  },
  activeCountry: "HK"
};

export default {
  name: "countryList",
  actions: {
    updateCountryList: payload =>
      dispatch({ type: "UPDATE_COUNTRY_LIST", payload }),

    updateMenuCountryList: payload =>
      dispatch({ type: "UPDATE_MENU_COUNTRY_LIST", payload }),

    updateDutyTax: payload => dispatch({ type: "UPDATE_DUTY_TAX", payload }),

    saveCountryCode: payload =>
      dispatch({ type: "SAVE_COUNTRY_CODE", payload }),

    updateCountryIncludeHK: payload =>
      dispatch({ type: "UPDATE_COUNTRY_INCLUDE_HK", payload }),

    fetchCountryList: async function() {
      await dispatch({ type: "FETCH_COUNTRYLIST" });
      const data = await req.get({ api: "countriesList" });
      await this.updateCountryList(data);
    },
    fetchMenuCountryList: async function() {
      await dispatch({ type: "FETCH_MENU_COUNTRYLIST" });
      const data = await req.get({ api: "menuCountriesList" });
      await this.updateMenuCountryList(data);
    },
    fetchCountryIncludeHK: async function() {
      await dispatch({ type: "FETCH_COUNTRY_INCLUDE_HK" });
      const data = await req.get({ api: "region" });
      await this.updateCountryIncludeHK(data);
    },
    fetchDutyTax: async function(countryCode) {
      await dispatch({ type: "FETCH_DUTY_TAX" });
      if (countryCode !== "CN") {
        const data = await req.get({
          api: "countryDetailInfo",
          params: countryCode
        });
        await this.updateDutyTax(data);
      }
      await this.saveCountryCode(countryCode);
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "UPDATE_COUNTRY_LIST":
        return { ...state, countries: action.payload, getCountriesList: true };
      case "UPDATE_MENU_COUNTRY_LIST":
        return {
          ...state,
          menuCountries: action.payload,
          getMenuCountriesList: true
        };
      case "UPDATE_DUTY_TAX":
        return { ...state, dutyTax: action.payload };
      case "SAVE_COUNTRY_CODE":
        return {
          ...state,
          countryCode: action.payload,
          activeCountry: action.payload
        };
      case "UPDATE_COUNTRY_INCLUDE_HK":
        return { ...state, region: action.payload };
      default:
        return state;
    }
  }
};
